import { useQuery } from '@tanstack/react-query'

import { type OnboardingInfo } from 'components/member_onboarding_v2/types'
import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export function useGetMemberOnboardingInfo ({
  enrollmentEventId,
}: {
  enrollmentEventId: string;
}) {
  return useQuery<OnboardingInfo, GrapeAPIErrorType>({
    queryKey: ['enrollmentEvent', enrollmentEventId, 'onboarding'],
    queryFn: async () => {
      const response = await fetchWithHeaders(
        `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/onboarding`
      )
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
          requestId: response.headers.get('x-request-id') ?? undefined,
        })
      }
      return response.json()
    },
    retry: false,
  })
}
